<template>
  <div>
    <el-container style="position: absolute;top:0;bottom: 0;left: 0;right: 0;overflow: hidden;font-size:12px">
      <el-container style="height: 100%;">
        <!-- 主布局 -->
        <el-main class="bg-light" style="padding:0px; padding-bottom: 60px; position: relative;" v-loading="loading">
          <el-header class="d-flex align-items-center"
            style=" padding: 0px; background-color: #fff;box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);position: sticky; top: 0;width: 100%;z-index: 999;">
            <div :class="is_phone ? 'pl-3' : ''" class="mr-auto d-flex align-items-center">
              <div
                style="width: 100%;height: 60px;align-items:center;justify-content: center;display: flex; margin-left: 10px; cursor: pointer;"
                @click="$router.push('/')">

                <img style="height: 70%;object-fit:contain;" v-if="is_phone" src="../assets/img/logo.png" alt="">
                <img style="height: 70%;object-fit:contain;" v-else src="../assets/img/black.png" alt="">
              </div>
              <div class="console-title" @click="$router.push('/')">控制台
              </div>
            </div>

            <div ref="menuicon" class="ml-4" style="color: #545c64; font-size: 22px; cursor: pointer;padding:20px">
              <el-dropdown trigger="click" @command="changeLanguage">
                <span class="el-dropdown-link">
                  <!-- 添加徽标组件 -->
                  <el-badge :value="notificationCount" :max="99" class="badge-notification"
                    :hidden="notificationCount === 0">
                    <i class="iconfont icon-tongzhi ml-1"></i>
                  </el-badge>
                </span>

                <el-dropdown-menu slot="dropdown" class="message-dropdown">
                  <div class="message-header">
                    <span>{{ $t('layout.noReadMsg') }}（{{ notificationCount }}）</span>
                  </div>

                  <div class="message-list">
                    <template v-if="unreadMessages.length > 0">
                      <div v-for="(msg, index) in unreadMessages" :key="msg.id" class="message-item"
                        style="border-bottom:1px solid #ebeef5;">
                        <div class="message-content">
                          <div class="message-title">
                            {{ msg.title }}
                          </div>
                          <div class="message-body" v-if="msg.content.length > 20"
                            v-html="msg.content.substring(0, 20) + '....'"></div>
                          <div class="message-body" v-else v-html="msg.content"></div>
                          <div class="message-time">{{ msg.create_time }}</div>
                        </div>
                        <!-- <el-divider v-if="index < unreadMessages.length - 1" /> -->
                      </div>
                    </template>
                    <div v-else class="empty-message">
                      {{ $t('layout.noMessgae') }}
                    </div>
                  </div>
                  <div class="message-header text-blue">
                    <span @click="toMsg" style="cursor: pointer;">{{ $t('layout.lookMax') }}<i
                        class="iconfont icon-tiaozhuan-zhuanqu"></i></span>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div ref="menuicon" style="color: #545c64; font-size: 22px; cursor: pointer;padding:20px">
              <el-dropdown trigger="hover" @command="changeLanguage">
                <span class="el-dropdown-link">
                  {{ currentLangLabel }}
                  <i class="iconfont icon-yuyan ml-1"></i>
                </span>

                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="cn">中文</el-dropdown-item>
                  <el-dropdown-item command="en">English</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <!-- <div ref="menuicon" class="ml-4" @click="showUserInfoModel(1)" style="color: #545c64; font-size: 22px; cursor: pointer;padding:20px">
							12
						</div> -->
            <el-menu :default-active="navBar.active" mode="horizontal" @select="handleSelect"
              style="height: 60px;border: unset;" menu-trigger="click">

              <el-submenu v-if="(user && user.name) || !needAuth" index="100">
                <template slot="title">
                  <el-avatar size="small" :src="user && user.head ? user.head : user_mo"></el-avatar>
                  <span v-show="!is_phone" class="ml-1">{{ user && user.name ? user.name : $t('layout.guest') }}</span>
                </template>
                <el-menu-item v-if="user && user.name" class="top-right-but" index="100-1"><i
                    class="el-icon-user"></i>{{
                      $t('layout.up_info') }}</el-menu-item>
                <el-menu-item v-if="user && user.name" class="top-right-but" index="100-3"><i class="el-icon-key"></i>{{
                  $t('layout.up_pass') }}</el-menu-item>
                <el-menu-item v-if="user && user.name" class="top-right-but" index="100-2"><i
                    class="el-icon-switch-button"></i>{{
                      $t('layout.Logout') }}</el-menu-item>
              </el-submenu>

              <el-menu-item v-if="needAuth && (!user || !user.name)" index="100-4" @click="toLogin">
                <i class="el-icon-right"></i>
                {{ $t('layout.toLogin') }}
              </el-menu-item>
            </el-menu>

          </el-header>
          <div style="z-index: 20;position: relative;padding:20px 40px ">
            <!-- 主内容 -->
            <router-view ref="contentMain"></router-view>
            <!-- <el-backtop target=".el-main" :bottom="100">
              <div style="{height: 100%; width: 100%; box-shadow: 0 0 6px rgba(0,0,0, .12); text-align: center;line-height: 40px;color: #1989fa;}">
              </div>
            </el-backtop> -->
          </div>


        </el-main>
      </el-container>
    </el-container>

    <!-- 修改密碼 -->
    <!-- <pass-mode v-if="user && user.name" :isphone="is_phone" :passModel="passModel" @hide="hidePassModel"></pass-mode> -->

    <!-- 修改个人资料 -->
    <!-- <info-edit v-if="user && user.name" :isphone="is_phone" :infoModel="infoModel" @hide="hideInfoModel"></info-edit> -->

    <!-- 个人资料 -->
    <!-- <user-info :isphone="is_phone" :userInfoModel="userInfoModel" :userId="userId" @hide="hideUserInfoModel"></user-info> -->
  </div>
</template>

<script>
import common from '@/common/mixins/common.js';
import passMode from '../components/common/pass-mode.vue';
import { mapActions } from 'vuex';
import infoEdit from '../components/common/info-edit.vue';
import expressInfo from '../components/common/express-info.vue';
// import userInfo from '../components/common/user-info.vue';

import elementLocale from 'element-ui/lib/locale';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import enLocale from 'element-ui/lib/locale/lang/en';

import {
  mapState,
  mapMutations
} from 'vuex';
export default {

  mixins: [common],
  components: {
    passMode,
    infoEdit,
    expressInfo,
    // userInfo
  },
  provide() {
    return {
      layout: this
    }
  },
  data() {
    return {
      language: localStorage.getItem('language') || 'cn', // 读取本地存储的语言
      langOptions: {
        'cn': '中文',
        'en': 'English'
      },

      notificationCount: 0,
      unreadMessages: [],

      userInfoModel: false,
      userId: 0,

      num_list: {},
      isCollapse: false,
      infoModel: false,
      expressModel: false,
      expressData: [],
      user_mo: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      bran: [],
      branTitle: '',
      passModel: false,
      loading: false,
      webSocket: null,
      // scoketUrl: 'wss://api.yifangmeng.com:2348?xuan_type=admin_web&token='+window.sessionStorage.getItem('token'),
      scoketUrl: 'wss://api.lets-go.fun:2348?xuan_type=admin_web&token=' + window.sessionStorage.getItem('token'),
      screenWidth: 0,
      is_phone: false,
      index_p: {
        gutter: 20,
        span1: 9,
        span3: 6,
        span2: 12,
        gutter2: 60,
        cardwidth: ''
      },
      needAuth: true
    }
  },
  created() {
    //初始化菜單信息
    // this.navBar = this.$conf.navBar
    //this._isMobile()
    // 面包屑导航信息
    // this.getRouterBran()
    // 初始化选中菜單
    // this.__initNavBar()
    // this.initSocket()
    // this.getPageNum()
    // this.newTreeDara()

    // 检查当前路由是否需要登录
    this.checkRequireAuth();
  },
  destroyed() {
    // 页面销毁關閉连接
    // this.webSocket.close()
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    });
  },
  watch: {
    $route: {
      handler(to, from) {
        this.checkRequireAuth();
      },
      immediate: true
    }
  },
  computed: {
    currentLangLabel() {
      return this.langOptions[this.language]; // 获取当前语言的名称
    },
    ...mapState({
      user: state => state.user.user,
      navBar: state => state.menu.navBar

    }),
  },

  methods: {
    toMsg() {
      this.$router.push({
        name: 'data_message'
      })
    },
    toLogin() {
      this.$router.push({
        name: 'login'
      })
    },
    changeLanguage(lang) {
      if (this.language == lang) {
        return false
      }
      this.language = lang;
      this.$i18n.locale = lang;
      localStorage.setItem('language', lang);

      elementLocale.use(lang === 'cn' ? zhLocale : enLocale);
      this.$message.success(this.$t('message.switchSuccess'));
      // 刷新页面（强制重新加载应用）
      window.location.reload(); // 最直接的方式
    },

    ...mapActions(['triggerRefresh']),
    refreshPage() {
      this.triggerRefresh(); // 触发刷新
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
      if (this.screenWidth < 768) {
        this.is_phone = true
      } else {
        this.is_phone = false
      }
      this.phoneHtml()
    },
    phoneHtml() {
      if (this.is_phone) {
        this.index_p = {
          gutter: 10,
          span1: 24,
          span3: 24,
          span2: 24,
          gutter2: 0,
          cardwidth: '110px'
        }
      } else {

        this.index_p = {
          gutter: 20,
          span1: 9,
          span3: 6,
          span2: 12,
          gutter2: 60,
          cardwidth: '160px'
        }
      }

    },
    // 建立连接
    initSocket() {
      // 有參數的情况下：
      // 没有參數的情况:接口
      // let url1 = 'ws://localhost:9998'
      this.webSocket = new WebSocket(this.scoketUrl)
      this.webSocket.onopen = this.webSocketOnOpen
      this.webSocket.onclose = this.webSocketOnClose
      this.webSocket.onmessage = this.webSocketOnMessage
      this.webSocket.onerror = this.webSocketOnError

    },
    // 建立连接成功後的狀態
    webSocketOnOpen() {
      console.log('websocket连接成功amdin');
    },
    // 获取到後台消息的事件，操作數据的代碼在onmessage中书写
    webSocketOnMessage(res) {
      // res就是後台实时傳过来的數据
      if (res.data.indexOf("apiSendXuanMessage") >= 0) {
        let list = JSON.parse(res.data);
        console.log(list)
        if (list.type == 'apiSendXuanMessage') {
          let data = list.data
          if (data.type == 1) {
            this.getPageNum()
          }
        }
      }
      //给後台發送數据
      //this.webSocket.send("發送數据");
    },
    // 關閉连接
    webSocketOnClose() {
      this.webSocket.close()
      console.log('websocket连接已關閉');
    },
    //连接失敗的事件
    webSocketOnError(res) {
      console.log('websocket连接失敗');
      // 打印失敗的數据
      console.log(res);
    },



    __initNavBar() {
      let r = localStorage.getItem('navActive')
      if (r) {
        r = JSON.parse(r)
        this.navBar.active = r.top
        this.slideMenuActive = r.left
        this.toUrl()
      }
    },


    _isMobile() {
      //        let flag =             navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)

      // if(flag){
      // 	this.is_phone = false
      // }else{
      // 	this.is_phone = true
      // }
      //    console.log(flag)
    },


    showExpressModel(data) {

      this.expressData.e_number = data
      this.expressData.activities = []
      this.expressData.is_data = 0

      this.axios.post('/admin/data/checkExpressData', { e_number: data }, {
        token: true,
        loading: true
      }).then(res => {
        let all = res.data
        if (all.code == 1) {

          if (all.data.list.list.length > 0) {
            this.expressData.activities = all.data.list.list
            this.expressData.is_data = 1
          }
          this.expressModel = true
        }
        //this.getPageNum()
      }).catch(err => {
        // 失敗
        this.expressModel = true
      })


    },
    hideExpressModel() {
      this.expressModel = false
    },

    //页面未處理數量
    getPageNum() {
      this.axios.post('/admin/user/adminPageNum', {}, {
        token: true,
      }).then(res => {

        let all = res.data
        let list = all.data.list
        this.notificationCount = list.msgCount
        this.unreadMessages = list.msgList

      }).catch(err => {
        // 失敗

      })
    },
    // 获取面包屑导航信息
    getRouterBran() {
      let b = this.$route.matched.filter(v => v.name)
      let arr = []
      b.forEach((v, k) => {
        if (v.name === 'index' || v.name === 'layout') return
        arr.push({
          name: v.name,
          path: v.path,
          title: v.meta.title
        })
        this.branTitle = v.meta.title;
      })
      if (arr.length > 0) {
        arr.unshift({
          name: 'index',
          path: '/index',
          title: 'home'
        });
      }
      this.bran = arr
    },
    hideInfoModel() {
      let user = JSON.parse(window.sessionStorage.getItem('user'))
      this.user.name = user.name
      this.user.head = user.head
      this.infoModel = false
    },
    showUserInfoModel(uid) {
      this.userId = uid
      this.userInfoModel = true
    },
    hideUserInfoModel() {
      this.userInfoModel = false
    },
    hidePassModel() {
      this.passModel = false
    },
    handleSelect(key, keyPath) {
      if (key == '200') {
        return false
      }
      if (key === '100-1') {
        return this.infoModel = true
      }
      if (key === '100-3') {
        return this.passModel = true
      }
      if (key === '100-2') {
        //退出
        return this.logout();
      }
      this.navBar.active = key;
      // 跳转到當前激活
      this.slideMenuActive = '0'
      if (this.slideMenus.length > 0) {
        this.$router.push({
          name: this.slideMenus[this.slideMenuActive].pathname
        })
      }
    },
    logout() {
      //請求接口
      this.axios.post('/admin/user/logout', {}, {
        token: true,
        loading: true
      }).then(res => {
        //成功後
        this.$message(this.$t('message.logout_ok'))
        this.$store.commit('logout')
        //返回到登錄页
        this.$router.push({
          name: 'login'
        })
      }).catch(err => {
        //失敗
        this.$message(this.$t('message.logout_ok'))
        this.$store.commit('logout')
        this.$router.push({
          name: 'login'
        })
      })
    },
    slideSelect(key, keyPath) {
      this.slideMenuActive = key
      if (this.is_phone) {
        this.isCollapse = true
      }
      localStorage.setItem('slideMenuActive', key); // 保存选中状态
      this.toUrl();
    },
    toUrl(data = {}) {
      let keys = new Array(); //定义一數組
      keys = this.slideMenuActive.split("_");
      if (keys.length === 2) {
        this.$router.push({
          name: this.slideMenus[keys[0]].child[keys[1]].pathname
        })
      } else {
        //跳转到指定页面
        this.$router.push({
          name: this.slideMenus[this.slideMenuActive].pathname,
          params: data
        })
      }
    },
    checkRequireAuth() {
      const route = this.$route;
      this.needAuth = true;
      if (route.meta.noAuthRequired) {
        this.needAuth = false;
      } else if (route.matched.some(record => record.meta.noAuthRequired)) {
        // 如果路由自身没有设置，但父级路由设置了noAuthRequired，则采用父级设置
        this.needAuth = false;
      }
    },
  }
}
</script>
<style lang="scss">
.message-dropdown {
  width: 360px;
  padding: 0 !important;

  .message-header {
    padding: 12px 16px;
    border-bottom: 1px solid #ebeef5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;

  }

  .message-list {
    max-height: 400px;
    overflow-y: auto;

    .message-item {
      padding: 12px 16px;
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: #f5f7fa;
      }

      &.unread {
        background: #f0faff;
      }
    }

    .message-content {
      position: relative;

      .dot {
        position: absolute;
        left: -8px;
        top: 50%;
        transform: translateY(-50%);
        width: 6px;
        height: 6px;
        background: #f56c6c;
        border-radius: 50%;
      }
    }

    .message-title {
      font-weight: 400;
      color: #303133;
      margin-bottom: 4px;
      font-size: 14px;
    }

    .message-body {
      font-size: 12px;
      color: #606266;
      line-height: 1.5;
      // @include text-ellipsis(2);
    }

    .message-time {
      font-size: 12px;
      color: #909399;
      margin-top: 4px;
    }

    .empty-message {
      padding: 20px;
      text-align: center;
      color: #909399;
    }
  }

  .el-divider {
    margin: 8px 0;
  }
}


.top-right-but {
  i {
    font-size: 14px !important;
  }
}

.left-menu-class .el-submenu__title:hover {
  background-color: transparent !important;

  span,
  i {
    color: #ff9561;
  }
}

.left-menu-class .el-menu-item:hover,
.el-menu-item:focus {
  background-color: transparent !important;

  span,
  i {
    color: #ff9561;
  }
}

// .left-menu-class .el-breadcrumb__inner.is-link:hover, .el-breadcrumb__inner a:hover {
// 	color: #ff9561;
// 	cursor: pointer;
// }
.left-menu-class .el-breadcrumb__inner.is-link,
.el-breadcrumb__inner a {
  font-weight: 200 !important;
}

.left-menu-class .el-breadcrumb__separator {
  font-weight: 200 !important;
}

.left-menu-class .xial {
  height: 46px !important;
  line-height: 46px !important;
}

.left-menu-class .el-submenu .el-menu-item {
  height: 46px !important;
  line-height: 46px !important;
}

.left-menu-class .el-submenu__title {
  height: 46px !important;
  line-height: 46px !important;
}

.left-menu-class {
  span {
    font-size: 12px;
  }

  i {
    font-size: 14px !important;
    margin-right: 10px !important;
  }

}






.el-dropdown-link {
  color: #545c64;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}


.tis_btn {
  width: 30px;
  height: 30px;
  line-height: 30px;
  padding: 0 !important;
}

.money_text {
  color: #dc3545 !important;
  font-weight: bold !important;
}

.content_huan {
  word-wrap: break-word !important;
  /* 單词换行 */
  word-break: break-word !important;
  /* 支持非標准浏览器 */
  white-space: pre-wrap !important;
  /* 保留空格和换行符 */
}

.el-dialog__title {
  font-size: 16px !important;
}

/* 控制台样式优化 */
.console-title {
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: #303133;
  width: 80px;
}
</style>
